import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

/**
 * Connect to the WebSocket server.
 * Safe to call multiple times — returns existing connection if already connected.
 */
export function connectSocket(baseUrl: string, tenantId?: string): Socket {
  if (socket?.connected) return socket;

  // Clean up any stale socket before reconnecting
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
  }

  socket = io(baseUrl, {
    auth: tenantId ? { tenantId } : undefined,
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
  });

  return socket;
}

/**
 * Disconnect from the WebSocket server.
 */
export function disconnectSocket(): void {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
}

/**
 * Subscribe to a WebSocket event.
 * Returns an unsubscribe function for cleanup.
 */
export function onEvent(event: string, callback: (...args: any[]) => void): () => void {
  if (!socket) return () => {};
  socket.on(event, callback);
  return () => { socket?.off(event, callback); };
}
